const GtmOnVue = {
    // 買取申込情報　送信用
    sendGAEvent: function(
        event,
        page_id,
        kaitori_num,
        campaign_code,
        campaign_code_auto,
        campaign_code_selected,
        buyback_code, 
        mail_send,
        box,
        shuka_ymd,
        shuka_time,
        hurikomi_houhou,
        has_introducer,
        introducer_id
    ) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': event,
            'page_id': page_id,
            'kaitori_num': kaitori_num || null,
            'campaign_code': campaign_code || null,
            'campaign_code_auto': campaign_code_auto || null,
            'campaign_code_selected': campaign_code_selected || null,
            'buyback_code': buyback_code || null, 
            'mail_send': mail_send || null,
            'box': box || null,
            'shuka_ymd': shuka_ymd || null,
            'shuka_time': shuka_time || null,
            'hurikomi_houhou': hurikomi_houhou || null,
            'has_introducer': has_introducer || null,
            'introducer_id': introducer_id || null,
        });
    },

    sendGAEventVabooOfferCompleted: function(
        kaitori_num,
        campaign_code,
        mail_send,
        box,
        shuka_ymd,
        shuka_time,
        hurikomi_houhou,
        create_main_site_account
    ) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          'event': 'conversion_buy',
          'page_id': (new URL(window.location.href)).pathname,
          'kaitori_num': kaitori_num,
          'campaign_code': campaign_code,
          'mail_send': mail_send,
          'box': box,
          'shuka_ymd': shuka_ymd,
          'shuka_time': shuka_time,
          'hurikomi_houhou': hurikomi_houhou,
          'create_main_site_account': create_main_site_account,
        });
    },

    sendGAEventCharibonOfferCompleted: function(
        kaitori_num,
        campaign_code,
        mail_send,
        box,
        shuka_ymd,
        shuka_time,
        hurikomi_houhou,
        supportgroup_id,
        vboffice_code
    ) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          'event': 'conversion_buy',
          'page_id': (new URL(window.location.href)).pathname,
          'kaitori_num': kaitori_num,
          'campaign_code': campaign_code,
          'mail_send': mail_send,
          'box': box,
          'shuka_ymd': shuka_ymd,
          'shuka_time': shuka_time,
          'hurikomi_houhou': hurikomi_houhou,
          'supportgroup_id': supportgroup_id,
          'vboffice_code': vboffice_code
        });
    },

    // チャリボン申し込みの完了ページより前のページで使う
    sendGAEventCharibonOfferAll: function(
        supportgroup_id,
        campaign_code,
        vboffice_code
    ) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          // 'event': '', // イベント名はなしとする
          'page_id': (new URL(window.location.href)).pathname,
          'supportgroup_id': supportgroup_id,
          'campaign_code': campaign_code,
          'vboffice_code': vboffice_code
        });
    },
}

export default GtmOnVue;
